import { render, staticRenderFns } from "./InfoTilesContainer.vue?vue&type=template&id=27b88c54&scoped=true"
import script from "./InfoTilesContainer.vue?vue&type=script&lang=js"
export * from "./InfoTilesContainer.vue?vue&type=script&lang=js"
import style0 from "./InfoTilesContainer.vue?vue&type=style&index=0&id=27b88c54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b88c54",
  null
  
)

export default component.exports